<template>
  <div>
    <div v-if="isDetail">
      <Detail ref="Detail" @back="isDetail = false"></Detail>
    </div>
    <page-header-wrapper v-else>
      <a-card :bordered="false">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" labelAlign="right">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item label="旧系统编号">
                  <a-input v-model="queryParam.oldCode" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="名称">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.name" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="创建人名">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.creatorName" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="(!advanced && 6) || 24" :sm="24">
                <span class="table-page-search-submitButtons"
                  :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                  <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                      {{ advanced ? '收起' : '展开' }}
                      <a-icon :type="advanced ? 'up' : 'down'" />
                    </a> -->
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
          :bordered="tableBordered">
          <span slot="city" slot-scope="text, record"> {{ record.city }}{{ record.area }} </span>
          <span slot="subTime" slot-scope="text, record">
            {{ parseTime(record.subTime) }}
          </span>
          <!-- <span slot="status" slot-scope="text, record">
            <a-tag color="red" v-if="record.status"> 禁用 </a-tag>
            <a-tag color="green" v-else> 启用 </a-tag>
          </span> -->
          <span slot="urlVal" slot-scope="text, record">
            <div>
              {{ record.urlVal }}
              <a-button type="link" @click="handleCopy(record.urlVal)">复制</a-button>
            </div>
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
          :total="total" :page-size="queryParam.pageSize" :showTotal="(total) => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange" @change="changeSize" />
      </a-card>
    </page-header-wrapper>
  </div>
</template>
<script>
import { orderVr } from '@/api/pressure/oldSystem'
//   import { regionList } from '@/api/pressure/oldSystem'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { isDate } from 'lodash'
export default {
  name: 'Post',
  components: {
    //   CreateForm,
    //   Detail,
    //   Examine,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    firmId: {
      type: [String, Number],
    },
    regionId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      value: [],
      isDetail: false,
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
          width: '10%',
          align: 'center',
        },
        {
          title: '旧系统编码',
          dataIndex: 'oldCode',
          align: 'center',
          visible: false,
        },
        {
          title: '创建人名',
          dataIndex: 'creatorName',
          align: 'center',
          visible: false,
        },
        {
          title: 'VR地址',
          dataIndex: 'urlVal',
          scopedSlots: { customRender: 'urlVal' },
          align: 'center',
          visible: false,
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          width: '10%',
          align: 'center',
        },
      ],
      orderType: 0,
      status: 1,
      agentList: [],
      listRegion: [],
    }
  },
  filters: {},
  created() {
    // console.log(this.userTentant.tenantId, 'userTentant');
    // const tenantId = this.userTentant.tenantId
    // if (tenantId == '510082352907792384') {
    //   this.queryParam.tenantId = 1
    // } else if (tenantId == '552862209223647232') {
    //   this.queryParam.tenantId = 2
    // } else {
    //   this.queryParam.tenantId = tenantId
    // }
    this.getList()
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    ...mapGetters(['nickname', 'infoUser', 'userTentant']),
  },
  watch: {},
  methods: {
    // 点击跳转详情
    handleDetail(e) {
      this.isDetail = true
      this.$nextTick(() => {
        this.$refs.Detail.init(e, 1)
      })
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
      this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
    },
    // 查代理商
    getAgent() {
      // listTenant({ pageNum: 1, pageSize: 9999, type: 1 }).then((res) => {
      //   this.agentList = res.data.records
      //   console.log(this.agentList, '的点点滴滴this.agentListthis.agentList')
      // })
    },
    // 查区域
    getQu() {
      regionList({ pageNum: 1, pageSize: 9999, type: 1 }).then((res) => {
        this.listRegion = res.data
      })
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      orderVr(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 复制
    handleCopy(scope) {
      console.log()
      const save = function (e) {
        e.clipboardData.setData('text/plain', scope)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', save) // 添加一个copy事件
      document.execCommand('copy') // 执行copy方法
      // 复制成功提示
      this.$message.success('复制成功')
    },
    // 下载验收报告
    handleLookDown(e) {
      acceptanceReport({ id: e.id }).then((res) => {
        // console.log(res,'resresres');
        // this.$message.success('下载成功')
        window.open(this.$url + res.data)
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
        regionId: undefined,
        orderType: undefined,
      }
      if (this.orderType) {
        this.queryParam.orderType = this.orderType
      } else {
        this.queryParam.status = this.status
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 禁用启用
    handleDeletes(row) {
      var that = this
      // let ids = []
      // if (row.id) {
      //   ids = [row.id]
      // } else {
      //   ids = this.ids
      // }
      const text = '是否要作废此订单?'
      this.$confirm({
        title: text,
        onOk() {
          return statusObj({ id: row.id }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() { },
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否要作废此订单?',
        onOk() {
          return orderVoid({ id: row.id }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() { },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'fix/order/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },
  },
}
</script>